import { getCurrentLocale } from 'cadenza/utils/i18n/i18n';

import { DecimalFormat } from './DecimalFormat';

/*
 * DecimalFormat uses '.' as decimal separator and ',' as grouping separator.
 * This patch adapts this behavior to respect the configured locale.
 */
export class PatchedDecimalFormat extends DecimalFormat {

  static get groupingSeparator () {
    return (1000).toLocaleString(getCurrentLocale())[1];
  }

  static get decimalSeparator () {
    return (0.1).toLocaleString(getCurrentLocale())[1];
  }

  format (value) {
    if (value === null || value === undefined) {
      return '';
    }
    if (isNaN(value)) {
      return value;
    }
    return super.format(value)
      .replace('.', '{decimalSeparator}')
      .replace(/,/g, PatchedDecimalFormat.groupingSeparator)
      .replace('{decimalSeparator}', PatchedDecimalFormat.decimalSeparator);
  }

  formatBack (formattedValue) {
    if (formattedValue === null || formattedValue === undefined) {
      return '';
    }
    if (typeof formattedValue === 'number') {
      return String(formattedValue);
    }
    return formattedValue
      .replace(new RegExp('\\' + PatchedDecimalFormat.groupingSeparator, 'g'), '')
      .replace(PatchedDecimalFormat.decimalSeparator, '.');
  }

}
